import { render, staticRenderFns } from "./AllBlogPosts.vue?vue&type=template&id=035bb84e&scoped=true&"
import script from "./AllBlogPosts.vue?vue&type=script&lang=js&"
export * from "./AllBlogPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035bb84e",
  null
  
)

export default component.exports